// extracted by mini-css-extract-plugin
module.exports = {"container":"Avatar_container__1ZzM4","default":"Avatar_default__RB-lP","small":"Avatar_small__3sweN","large":"Avatar_large__Z4UsU"};